import { NavLink } from 'react-router-dom'
import { clsx } from 'clsx'

const navItems = [
  { path: '/', label: '仪表盘', icon: '📊' },
  { path: '/data', label: '数据管理', icon: '📁' },
  { path: '/dns', label: 'DNS 管理', icon: '🌐' },
  { path: '/settings', label: '设置', icon: '⚙️' },
]

interface SidebarProps {
  isOpen: boolean
  onClose: () => void
}

export default function Sidebar({ isOpen, onClose }: SidebarProps) {
  return (
    <aside
      className={clsx(
        'w-64 card-gradient border-r border-gray-100 flex flex-col shadow-soft-lg backdrop-blur-sm',
        'fixed lg:static inset-y-0 left-0 z-30 transform transition-all duration-300 ease-out',
        isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      )}
    >
      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-100">
        <h1 className="text-lg md:text-xl font-bold text-gray-800">
          🛠️ Tools Admin
        </h1>
        {/* 移动端关闭按钮 */}
        <button
          onClick={onClose}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100 text-gray-600 transition-colors duration-200"
          aria-label="关闭菜单"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      {/* 导航菜单 */}
      <nav className="flex-1 py-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            onClick={onClose}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 px-6 py-3 text-sm transition-colors duration-200 mx-2 rounded-lg',
                isActive
                  ? 'bg-primary-50 text-primary-700 font-medium'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              )
            }
          >
            <span className="text-lg">
              {item.icon}
            </span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
      
      {/* 底部信息 */}
      <div className="p-4 border-t border-gray-100 text-xs text-gray-500 bg-gradient-to-t from-gray-50/50">
        <p className="animate-fade-in">© 2024 Tools Set</p>
      </div>
    </aside>
  )
}
